import loadable from '@loadable/component'

export default [
  {
    // 开业大酬宾-活动页
    path: '/temporary/openingCeremony',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-temporary-openingCeremony" */ '~/pages/Temporary/OpeningCeremony/pages/Home'
        )
    ),
  },
  {
    // 开业大酬宾-榜单历史页
    path: '/temporary/openingCeremony/history',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-temporary-openingCeremony-history" */ '~/pages/Temporary/OpeningCeremony/pages/History'
        )
    ),
  },
  {
    // 开业大酬宾-全局弹窗
    path: '/temporary/openingCeremony/modal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-temporary-openingCeremony-Modal" */ '~/pages/Temporary/OpeningCeremony/pages/Modal'
        )
    ),
  },
]
